//import required libraries
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/js/dist/util'
import 'bootstrap/js/dist/popover'
import './site.scss'
const $ = require('jquery');

$(() => {

    // "Mobile" pre tuto stranku znamena viewport ktore NIE su xl+
    const isMobile = () => window.matchMedia('(max-width: 1199.98px)').matches;

    let disableNavBarOnScroll = false;

    $('.nav-link').on('click', () => {
        if (!isMobile()) return;

        if (window.scrollY > 50) {
            $('#navbar').hide();
        }
        disableNavBarOnScroll = true;
        let prevScroll = window.scrollY;
        let enableScrollNavBarTimer = setInterval(() => {
            if (window.scrollY === prevScroll) {
                disableNavBarOnScroll = false;
                clearInterval(enableScrollNavBarTimer);
            }
            prevScroll = window.scrollY;
        }, 100);
    });

    let originScroll = 0;
    $(window).on('scroll', () => {
        if (!isMobile()) {
            // Desktop - povodna smart-scroll logika
            if (window.scrollY <= 50 || (!disableNavBarOnScroll && window.scrollY - originScroll < 0)) {
                $('#navbar').show();
            } else {
                $('#navbar').hide();
            }
            originScroll = window.scrollY;
            return;
        }

        // Mobile - vzdy zobrazene
        $('#navbar').show();
    });

    let enableResizeNavBarTimeout;
    $(window).on('resize', () => {
        disableNavBarOnScroll = true;
        if (enableResizeNavBarTimeout) {
            clearTimeout(enableResizeNavBarTimeout);
        }
        enableResizeNavBarTimeout = setTimeout(() => {
            disableNavBarOnScroll = false;
            enableResizeNavBarTimeout = null;
        }, 100);

        if (isMobile()) {
            $('#navbar').show();
        }
    });
});